import React from "react";
import ModalA11yWrapper from "./ModalA11yWrapper";

function DrawerA11yWrapper({
  open,
  onClose,
  labelledBy,
  describedBy,
  initialFocusRef,
  role = "dialog",
  width = 520,
  backdropStyle,
  containerStyle,
  children,
}) {
  const mergedBackdropStyle = {
    justifyContent: "flex-end",
    alignItems: "stretch",
    ...backdropStyle,
  };

  const mergedContainerStyle = {
    width: `min(90vw, ${width}px)`,
    height: "100%",
    maxHeight: "100vh",
    borderRadius: 0,
    ...containerStyle,
  };

  return (
    <ModalA11yWrapper
      open={open}
      onClose={onClose}
      labelledBy={labelledBy}
      describedBy={describedBy}
      initialFocusRef={initialFocusRef}
      role={role}
      backdropStyle={mergedBackdropStyle}
      containerStyle={mergedContainerStyle}
    >
      {children}
    </ModalA11yWrapper>
  );
}

export default DrawerA11yWrapper;
